import api from "@/assets/js/utils/api.js";
import showIcon from "@/assets/image/show.webp";
import unshowIcon from "@/assets/image/unshow.webp";

// ✅ 改用公用 Alert Service
import {
  showSuccess,
  showError,
  showLoading,
  hideLoading,
} from "@/assets/js/utils/alertService.js";

export default {
  name: "RegisterPage",
  data() {
    return {
      role: "",
      showPassword: false,
      showConfirmPassword: false,
      form: {
        name: "",
        phone: "",
        email: "",
        city: "",
        district: "",
        address: "",
        company: "",
        contact: "",
        title: "",
        hospital: "",
        doctor: "",
        password: "",
        confirm: "",
      },
      showIcon,
      unshowIcon,
    };
  },
  methods: {
    resetForm() {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = "";
      });
      this.showPassword = false;
      this.showConfirmPassword = false;
    },
    handleRegister() {
      if (this.form.password !== this.form.confirm) {
        showError("密碼與確認密碼不一致");
        return;
      }

      // 身份轉 Auth
      let auth = "User";

      if (this.role === "Supplier") auth = "Supplier";
      if (this.role === "DrugStore") auth = "DrugStore";
      if (this.role === "Doctor") auth = "User"; // ✅ 醫生先當一般會員

      // 組 payload 給後端
      const payload = {
        FullName: this.form.name,
        PhoneNumber: this.form.phone,
        Address: this.form.address,
        Email: this.form.email,
        Password: this.form.password,
        Auth: auth,
        CompanyName: this.form.company || this.form.hospital || "",
        JobTitle: this.form.title || this.form.doctor || "",
      };

      showLoading();

      api
        .post("/front/customer/register", payload)
        .then((res) => {
          hideLoading();
          if (res.data.success) {
            showSuccess("註冊成功");
            this.$router.push("/login");
          } else {
            showError(res.data.message || "註冊失敗");
          }
        })
        .catch((err) => {
          hideLoading();
          showError(err.response?.data?.message || "伺服器錯誤");
        });
    },
  },
};
